// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_b","heading":"ac"};